import { useLanguageStore } from "src/store/languageStore";
import ImageButton from "./image-button";
import { useNavigationStore } from "@/store/navigationStore";
import { useExplorationStore } from "@/store/explorationStore";
import Image from "src/components/image";

export default function AnnotationButton({ mode }: { mode: string }) {
  const NavigationAnnotationButton = () => {
    const annotationMode = useNavigationStore((state) => state.annotationMode);
    const switchAnnotationMode = useNavigationStore((state) => state.switchAnnotationMode);
    return annotationMode > 0 ? (
      <ImageButton
        className="button-glass-blur"
        src={
          annotationMode == 1
            ? "/assets/icon_annotation_on.png"
            : "/assets/icon_annotation_off.png"
        }
        onClick={() => switchAnnotationMode()}
        alt="rotate icon"
        size={32}
      />
    ) : (
      <></>
    );
  };

  return mode == "navigation" ? (
    <NavigationAnnotationButton />
  ) : <></>
}
